import type { LandingPromo } from "@/lib/api";

/**
 * The banner the storefront was built with: Kanata's website-launch promo.
 * Mirrors DefaultLandingPromo in the API.
 */
export const DEFAULT_PROMO: LandingPromo = {
  hidden: false,
  label: "Promo website launch",
  title: "Lebih lengkap,",
  accent: "",
  body: "Saatnya upgrade workspace dengan benefit lebih banyak saat kerja yang lebih nyaman.",
  items: [
    { image: "/promo/pallet.webp", title: "FREE\nPacking Kayu", subtitle: "Proteksi ekstra" },
    { image: "/promo/wheels.webp", title: "FREE\nPutar Wheels", subtitle: "Lebih fleksibel" },
    { image: "/promo/ongkir.webp", title: "Subsidi\nOngkir", subtitle: "Ke seluruh Indonesia" },
  ],
  stickerLabel: "Termasuk",
  stickerValue: "Rp 226.000",
  stickerNote: "Perlengkapan",
  image: "/promo/desk.webp",
  imageAlt: "Standing desk elektrik Kanata Karya",
  ctaLabel: "",
  ctaHref: "",
};

const KEY = "kanata:landing-promo";

/** The banner this browser last saw, like cachedHero. */
export function cachedPromo(): LandingPromo | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const p = JSON.parse(raw) as Partial<LandingPromo>;
    return typeof p.title === "string" && Array.isArray(p.items) ? { ...DEFAULT_PROMO, ...p } : null;
  } catch {
    return null;
  }
}

export function rememberPromo(p: LandingPromo): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(p));
  } catch {
    // Storage full or blocked: the next visit waits on the API.
  }
}
